<script>
  import options from './FrivilligePostsList.options'
  export default options
</script>

<template>
  <article class="kb-posts-list">
    <div class="kb-posts-list__container">
      <div class="kb-posts-list__container-group">
        <div class="kb-posts-list__container-group-element">
          {{ totalAmount }} {{ getLabel('numberOfPostsLabel') }}
        </div>
      </div>
      <div class="kb-posts-list__container-element">
        <a v-if="isMember" class="kb-button" :href="getLabel('createPostLink')">
          {{ getLabel('createPostLinkText') }}
          <span class="kb-button__icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#3C3C3C" fill-rule="evenodd" d="M15.238 1.688c.31-.538.998-.723 1.537-.412l2.598 1.5c.538.31.722.999.411 1.537l-9.936 17.21-.001.002-.453.784-3.586.96-.96-3.585L13.55 4.611 15.5 5.736l-.375.649-1.3-.75L6.6 18.15a1.496 1.496 0 0 1 1.47 1.204 1.496 1.496 0 0 1 1.777.67l9.288-16.086a.375.375 0 0 0-.137-.513l-2.598-1.5a.375.375 0 0 0-.513.138l-.562.974-.65-.375.563-.974Zm-6.04 19.461a.75.75 0 0 0-1.3-.75l-.65-.374a.75.75 0 1 0-1.298-.75l-.298.515.687 2.561 2.561-.686.297-.515Z" clip-rule="evenodd"/></svg>
          </span>
        </a>
      </div>
    </div>

    <ul class="kb-posts-list__wrapper">
      <template v-for="cardData, index in featuredPostSpotCards" :key="index">
        <li class="kb-posts-list__wrapper-element">
          <featuredPostSpotCard 
            :spotCardData="cardData"
          />
        </li>
      </template>
      <template v-for="post, index in posts" :key="index">
        <li class="kb-posts-list__wrapper-element">
          <GroupPost 
            :result="post"
            :comments="post.comments"
            :isFrivilligContext="true"
            :handlePostClick="handlePostClick"
          />
        </li>
      </template>
    </ul>

    <div class="kb-posts-list__actions">
      <p class="kb-posts-list__actions-element">{{ getLabel('resultOutForTitle', [posts.length + featuredPostSpotCards.length, totalAmount]) }}</p>
      <button v-if="posts.length + featuredPostSpotCards.length < totalAmount" v-on:click="getMorePosts" class="kb-button kb-button--full-color-spot">{{ getLabel('getMoreButtonLabel') }}</button>
    </div>
  </article>

  <div v-if="showSpinner" class="kb-spinner-overlay">
    <div class="kb-spinner-overlay__spinner"></div>
  </div>
</template>
